export default __webpack_public_path__ + "static/media/success.94610495.png";